import { t } from 'i18next'

import { orderOptionType } from '@/config'
import Lucide from '@/components/Base/Lucide'
import { getCurrencyConfig } from '@/utils/auth';
import { convertToBaseAmount, formatPriceByCurrency } from '@/utils/helper'

interface OptionItemProps {
    items: orderOptionType[],
    handleSelectOption: (optionId: string, indexValue: number, index: number, maxChoice: number) => void,
}

export default function OptionItem({ items, handleSelectOption }: OptionItemProps) {
    const getCurrency = getCurrencyConfig();

    return (
        <>
            <div className="text-base font-medium">{t("options")}</div>
            <div className="flex flex-col gap-2 mt-2">
                {items && items.map((optionItem: orderOptionType, indexOption: number) => (
                    <div key={indexOption}>
                        <div className="text-base flex gap-1 items-center">
                            <Lucide icon="Plus" className="w-3 h-3" />
                            {optionItem.name}
                        </div>
                        <div className="flex justify-between items-center pt-2">
                            <div className="flex gap-2">
                                <p className="font-semibold text-[12px] text-primary py-1 px-3 bg-primary/5 rounded-3xl">{t('minChoice')}: {optionItem.min || 1}</p>
                                <p className="font-semibold text-[12px] text-primary py-1 px-3 bg-primary/5 rounded-3xl">{t('maxChoice')}: {optionItem.max || 1}</p>
                            </div>
                            <div className="flex gap-2">
                                <p className="text-red-600 py-1 px-3 bg-red-600/5 rounded-3xl">{t('required')}</p>
                            </div>
                        </div>
                        {optionItem.values && optionItem.values.map((value, index) => (
                            <div key={index} className=''>
                                <div
                                    onClick={() => handleSelectOption(optionItem._id, index, indexOption, optionItem.max || 1)}
                                    className={`w-full border p-2 border-gray-200 rounded-md hover:bg-gray-100/30 cursor-pointer outline-none ring-0 focus:ring-0 focus:outline-none text-center flex justify-between gap-1 mt-3  whitespace-nowrap`}
                                >
                                    <div className="flex gap-2">
                                        {value.isCheck ?
                                            <Lucide icon="CheckSquare" className="text-primary stroke-[2]" />
                                            :
                                            <Lucide icon="Square" />
                                        }
                                        <span className="font-medium">{value.name}</span>
                                    </div>
                                    <span className="font-medium text-red-600">
                                        {
                                            formatPriceByCurrency(
                                                convertToBaseAmount(
                                                    Number(value.price),
                                                    getCurrency ? getCurrency.code : "USD",
                                                    // getCurrency?.rateToUSD
                                                ),
                                                getCurrency?.symbol
                                            )
                                        }
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </>
    )
}
